import _ from 'lodash';
import Modal from '../../../../_components/modal/modal.js';

import tpl from './link-player-modal.tpl.html';
import './link-player-modal.styles.less';

import LinkUserView from './link-user/link-user.view.js';

class LinkPlayerModal extends Modal {

	constructor (__player, __users) {
		super(tpl, {
			title: 'Link Player to User'
		}, {
			__users: __users,
			__player: __player
		});
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			btnClose: '.btn-close',
			userList: '.user-list'
		});
	}

	render(data) {
		super.render(data);

		_.forEach(this.options.__users.val(), (user, index) => {
			let linkUserView = new LinkUserView(
				_.extend({ userId: index }, user),
				{__player: this.options.__player}
			);
			linkUserView.appendTo(this.ui.userList);
		});

		this.ui.btnClose.click(() => this.close());
	}

	close(result) {
		this.ui.btnClose.off();

		super.close(result);
	}

}

export default LinkPlayerModal;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/admin-section/players/_modals/link-player-modal/link-player-modal.view.js